export const SET_LOADING = 'SET_LOADING'
export const SET_SC = 'SET_SC'
// export const ADD_SC_ROLES = 'ADD_SC_ROLES'
export const EDIT_SC = 'EDIT_SC'
// export const DELETE_SC_ROLES = 'DELETE_SC_ROLES'